'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRequiredForA11y = exports.elementType = exports.deprecated = exports.componentOrElement = exports.all = undefined;

var _all = require('./all');

var _all2 = _interopRequireDefault(_all);

var _componentOrElement = require('./componentOrElement');

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = require('./deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = require('./elementType');

var _elementType2 = _interopRequireDefault(_elementType);

var _isRequiredForA11y = require('./isRequiredForA11y');

var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.all = _all2.default;
exports.componentOrElement = _componentOrElement2.default;
exports.deprecated = _deprecated2.default;
exports.elementType = _elementType2.default;
exports.isRequiredForA11y = _isRequiredForA11y2.default;


//////////////////
// WEBPACK FOOTER
// ./~/prop-types-extra/lib/index.js
// module id = 251
// module chunks = 51